// Menu
$('#header #open').click(function() {
  $('#header .navigation').fadeIn();
  $('#header #open').hide();
  $('#header #close').show();
  $('body').addClass('overflow-hidden');
  return false;
});
$('#header #close').click(function() {
  $('#header .navigation').fadeOut();
  $('#header #open').show();
  $('#header #close').hide();
  $('body').removeClass('overflow-hidden');
  return false;
});

// Subscribe
// $('#canvas #mc_embed_signup #mce-EMAIL').click(function() {
//   $('#canvas #mc_embed_signup #mc-embedded-subscribe').fadeIn();
//   $('#canvasOverlay').fadeIn();
// });
// $('#canvasOverlay, #mc-embedded-subscribe, a').click(function() {
//   $('#canvas #mc_embed_signup #mc-embedded-subscribe').fadeOut();
//   $('#canvasOverlay').fadeOut();
// });

// Preloader
var images = [];
function preload() {
  for (var i = 0; i < arguments.length; i++) {
    images[i] = new Image();
    images[i].src = preload.arguments[i];
  }
}
preload(
  //www.michaelfelix.com/cdn/shop/t/15/assets/submit.svg?v=8224039423722065011681792314,
  //www.michaelfelix.com/cdn/shop/t/15/assets/submit-hover.svg?v=50656142180609957861681792314
);

// Home page
if ($('.template-index').length) {
  // Slideshow
  $('.slideshow').slick({
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3600,
    speed: 1200,
    fade: true,
    pauseOnHover: false,
    pauseOnFocus: false
  });
  // Scroll events
  $(window).on('scroll', function() {
    var scrollHeight = $(document).height();
    var scrollPosition = $(window).height() + $(window).scrollTop();
    // Jumbo logo
    if ($(this).scrollTop() > 250) {
      $('.jumbo-logo').fadeOut(300);
      $('#logo').css('opacity', '1');
    } else {
      $('.jumbo-logo').fadeIn(300);
      $('#logo').css('opacity', '0');
    }
    // Footer menu offset
    if ((scrollHeight - scrollPosition) / scrollHeight === 0) {
      // adjust margin on bottom corner links when scrolled to bottom
      $('#canvas #mc_embed_signup, #canvas #subscribe, #canvas #studio').addClass('bottom'); 
    } else {
      // reset margins on bottom corner links
      $('#canvas #mc_embed_signup, #canvas #subscribe, #canvas #studio').removeClass('bottom');
    }
  });
  // Header hover
  // $('#header').mouseenter(function() {
  //   if ($('#navigation').is(":hidden")) {
  //     $('#logo').css('opacity', '1');
  //   }
  // }).mouseleave(function() {
  //   if ($('#navigation').is(":hidden")) {
  //     $('#logo').css('opacity', '0');
  //   }
  // });
  // Menu
  $('#header #open').click(function() {
    if ($(window).scrollTop() < 250) {
      $('#logo').css('opacity', '1');
    }
    return false;
  });
  $('#header #close').click(function() {
    if ($(window).scrollTop() < 250) {
      $('#logo').css('opacity', '0');
    }
    return false;
  });
}

// Swatch popup
$('.swatch-popup').on('click', function() {
  var swatchImage = $(this).find('.swatch-thumb').attr('src');
  var swatchName = $(this).attr('title');
  $('#swatch').html(
    '<h3>' + swatchName + '</h3>' +
    '<img src="' + swatchImage + '" alt="' + swatchName + '">'
  );
  $('#swatchPopup').fadeIn();
  return false;
});
$('#swatchClose').on('click', function() {
  $('#swatchPopup').fadeOut();
  return false;
});

// Swatch list popup
$('.swatch-list-popup').on('click', function() {
  var swatchList = $(this).parent().parent().parent().html();  
  $('#swatchList').html(swatchList);
  $('#swatchListPopup').fadeIn();
  return false;
});
$('#swatchListClose').on('click', function() {
  $('#swatchListPopup').fadeOut();
  return false;
});

// Swatch list swatch popup
$('#swatchListPopup').on('click', '.swatch-popup', function() {
  var swatchImage = $(this).find('.swatch-thumb').attr('src');
  var swatchName = $(this).attr('title');
  $('#swatch').html(
    '<h3>' + swatchName + '</h3>' +
    '<img src="' + swatchImage + '" alt="' + swatchName + '">'
  );
  $('#swatchPopup').fadeIn();
  return false;
});

// Product page
if ($('.template-product').length) {
  // Infinite options
  function optionToggle(variant) {
    var toggle = $('.' + variant);
    var category = variant + '-options';
    var options = $('#infiniteoptions-container').children('div');
    var selection = toggle.find('option:selected').text().toLowerCase().split(' ').join('-');   
    // Initial page load
    $.each(options, function(index) {
      if ($(this).hasClass(category)) {
        if ($(this).hasClass(selection)) {
		  $(this).show();
        }
      }
    });
	// Changing the variants
    toggle.on('change', function() {
      selection = toggle.find('option:selected').text().toLowerCase().split(' ').join('-');
      // Show/hide infinite option select menus
      $.each(options, function(index) {
        // On matching variants
        if ($(this).hasClass(category)) {
          var categorySelect = $(this).find('select');
          // Deselect menus
          for (var i = 0; i < categorySelect.length; i++) {
            categorySelect[0].selectedIndex = 0;
          }
		  // Hide all
          $(this).hide();
        }
        // Now show the match
        if ($(this).hasClass(selection)) {
		  $(this).show();
        }
      });
    });
  }
  // Wait for app to load
  $(window).on('load', function() {
    setTimeout(function() {
      optionToggle('material');
      optionToggle('base');
    }, 1000);
  });
  // Scroll events
  $(window).on('scroll', function() {
    var scrollHeight = $(document).height();
    var scrollPosition = $(window).height() + $(window).scrollTop();
    var flowItems = $('#flowItems');
    var flowContent = $('#flowContent');
    // Dock sidebar above footer
    if (scrollPosition > flowItems.height()) {
      flowContent.css('position', 'absolute');
      flowContent.css('top', flowItems.height() - flowContent.outerHeight());
    } else {
      flowContent.css('position', 'fixed');
      flowContent.css('top', 'unset');
    }
  });
}

// Gallery Page
if ($('.template-page-gallery').length) {
  // Menu
  var galleryMenuLink = $('.gallery-menu a');
  var galleryCurrent = $('.gallery-current');
  var galleryPast = $('.gallery-past');
  // Toggle current/previous sections
  galleryMenuLink.on('click', function() {
    if ($(this).hasClass('gallery-menu-current')) {
      galleryMenuLink.removeClass('active');
      $(this).addClass('active');
      galleryPast.hide();
      galleryCurrent.show();
    }
    if ($(this).hasClass('gallery-menu-past')) {
      galleryMenuLink.removeClass('active');
      $(this).addClass('active');
      galleryPast.show();
      galleryCurrent.hide();
    }
    return false;
  });
}